import type { ReservationPartyLookupRequest } from '../Types/reservationTypes';

const isFiniteNumber = (value: number | undefined): value is number =>
  typeof value === 'number' && Number.isFinite(value);

export const buildReservationPartiesLookupUrl = (
  request?: ReservationPartyLookupRequest | void
): string => {
  const queryParams = new URLSearchParams();
  const normalizedSearch = request?.search?.trim();
  const ids = request?.ids;

  if (normalizedSearch) {
    queryParams.set('search', normalizedSearch);
  }

  if (Array.isArray(ids)) {
    ids.forEach((id) => {
      if (Number.isInteger(id)) {
        queryParams.append('ids', id.toString());
      }
    });
  }

  const take = request?.take;
  if (isFiniteNumber(take)) {
    queryParams.set('take', take.toString());
  }

  const query = queryParams.toString();
  return query.length > 0
    ? `/reservations/parties/lookup?${query}`
    : '/reservations/parties/lookup';
};
